import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Field } from 'redux-form';
import { intlShape } from 'react-intl';
import { isEmpty } from 'helpers/verify';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { InputField, LocationInputField } from 'components/FormFields';
import { CTA_COLOR_BY_NAME } from 'constants/colors';
import { messages } from './LeadGenForm.messages';
import { CODE_BY_ERROR as CODE_BY_LEAD_GEN_ERROR } from './LeadGenForm.saga';

export class LeadGenForm extends Component {
  handleSubmit = ({ email, location }) => {
    const { onWaitlistRequest, submissionType } = this.props;

    onWaitlistRequest({
      email,
      submissionType,
      location,
    });
  };

  renderError() {
    const error = this.props.formError || {};

    let errorMessage;
    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error.code === CODE_BY_LEAD_GEN_ERROR.ALREADY_ON_WAITLIST) {
      errorMessage = <LocalizableMessage message={messages.errorAlreadyOnWaitlist} />;
    } else if (error.code === CODE_BY_LEAD_GEN_ERROR.ALREADY_MEMBER) {
      const link = (
        <Link to="/login" target="_self">
          <LocalizableMessage message={messages.signIn} />
        </Link>
      );
      errorMessage = <LocalizableMessage message={messages.errorExistingAccount} values={{ link }} />;
    } else if (error.defaultMessage) {
      errorMessage = <LocalizableMessage message={error} />;
    } else if (!isEmpty(error)) {
      errorMessage = <LocalizableMessage message={messages.errorDefault} />;
    }

    if (errorMessage) {
      return <p className="lead-gen-form__error">{errorMessage}</p>;
    }
  }

  renderSuccess() {
    return (
      <p className="lead-gen-form__success">
        <LocalizableMessage message={messages.thanks} />
      </p>
    );
  }

  render() {
    const { ctaCopy, handleSubmit, hideLocation, singleLineBreakpoint = 'md', wasCaptured, intl } = this.props;

    return (
      <div className="lead-gen-form">
        <form method="post" onSubmit={handleSubmit(this.handleSubmit)}>
          <div className="grid">
            <div className={`grid__item ${singleLineBreakpoint}-2/5 pb-`}>
              <Field
                component={InputField}
                name="email"
                suppressErrorMessage
                inputAttributes={{
                  disabled: wasCaptured,
                  placeholder: intl.formatMessage(messages.email),
                }}
              />
            </div>
            {!hideLocation && (
              <div className={`grid__item ${singleLineBreakpoint}-2/5 ${singleLineBreakpoint}-pl pb`}>
                <Field
                  component={LocationInputField}
                  format={null}
                  name="location"
                  suppressErrorMessage
                  inputAttributes={{
                    disabled: wasCaptured,
                    placeholder: intl.formatMessage(messages.location),
                  }}
                />
              </div>
            )}
            <div className={`grid__item ${singleLineBreakpoint}-1/5 ${singleLineBreakpoint}-pl`}>
              <button
                type="submit"
                className={`${CTA_COLOR_BY_NAME.primary_solid} bt--width-full`}
                disabled={wasCaptured}>
                <LocalizableMessage message={ctaCopy || messages.submit} />
              </button>
            </div>
          </div>
        </form>
        {wasCaptured ? this.renderSuccess() : this.renderError()}
      </div>
    );
  }
}

LeadGenForm.propTypes = {
  intl: intlShape.isRequired,
  ctaCopy: PropTypes.string,
  formError: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleSubmit: PropTypes.func.isRequired,
  hideLocation: PropTypes.bool,
  submissionType: PropTypes.string,
  onWaitlistRequest: PropTypes.func.isRequired,
  singleLineBreakpoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'retina', 'none']),
  wasCaptured: PropTypes.bool,
};
